import * as monacoEditor from 'monaco-editor';
import React from 'react';

import { MonacoLanguage } from 'src/app/graph/shared/monacoHelpers/monacoHelpers';
import {
  MONACO_READONLY_OPTIONS,
  StudioEditorContainer,
  useStudioEditor,
} from 'src/hooks/useStudioEditor';

export const ReadonlyEditor = ({
  language,
  src,
  monacoOptions,
}: {
  language: MonacoLanguage;
  src: string;
  monacoOptions?: Partial<
    Pick<
      monacoEditor.editor.IStandaloneEditorConstructionOptions,
      | 'contextmenu'
      | 'glyphMargin'
      | 'readOnly'
      | 'wordWrap'
      | 'showFoldingControls'
    >
  > & { lineNumbers?: 'on' | 'off' };
}) => {
  const editor = useStudioEditor({
    language,
    defaultValue: src,
    ...MONACO_READONLY_OPTIONS,
    ...monacoOptions,
  });
  React.useEffect(() => {
    // When contents change in a read only editor, reset selection
    const disposable = editor.onDidChangeModelContent(() =>
      editor.setSelection(new monacoEditor.Range(1, 1, 1, 1)),
    );
    return () => disposable.dispose();
  }, [editor, monacoOptions?.wordWrap]);

  React.useEffect(() => {
    editor.updateOptions({
      ...MONACO_READONLY_OPTIONS,
      ...monacoOptions,
    });
  }, [editor, monacoOptions]);

  return <StudioEditorContainer editor={editor} className="h-full" />;
};
